import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface FechamentoItem {
    dataInicio: number
    valorTotalVendido: number
}

export interface DetalhamentoFechamento {
    detalhamento: string
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaErroRaw = { codErro: number; mensagem?: string }

function isErroBackend(data: unknown): data is RespostaErroRaw {
    return (
        typeof data === "object" &&
        data !== null &&
        !Array.isArray(data) &&
        "codErro" in data &&
        (data as RespostaErroRaw).codErro > 0
    )
}

function erroParaRespostaRaw(error: unknown): RespostaErroRaw {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem }
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" }
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" }
}

export const obterHistoricoFechamentos = async function (
    authorization: string,
    dataInicio?: string,
    dataFim?: string
): Promise<FechamentoItem[] | ErroApi> {
    try {
        const query = new URLSearchParams()
        if (dataInicio) query.set("dataInicio", dataInicio)
        if (dataFim) query.set("dataFim", dataFim)
        const params = query.toString() ? `?${query.toString()}` : ""
        const response = await api
            .get<FechamentoItem[] | RespostaErroRaw>(`caixa/ObterHistoricoFechamentos${params}`, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        if (response.data === null || response.data === undefined) {
            return []
        }
        return response.data as FechamentoItem[]
    } catch (error) {
        RegistrarLogErro(error, "ObterHistoricoFechamentos", dataInicio || "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const obterDetalhamentoFechamento = async function (
    authorization: string,
    timestamp: number
): Promise<DetalhamentoFechamento | ErroApi> {
    try {
        const response = await api
            .get<DetalhamentoFechamento | RespostaErroRaw>(
                `caixa/ObterDetalhamentoFechamento?timestamp=${timestamp}`,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) as RespostaErroRaw }
            })

        if (isErroBackend(response.data)) {
            return { retornoErro: response.data.codErro, mensagem: response.data.mensagem ?? "" }
        }
        return response.data as DetalhamentoFechamento
    } catch (error) {
        RegistrarLogErro(error, "ObterDetalhamentoFechamento", String(timestamp))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
